import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiPalette } from '@euler/model/bi/viz';
import { memo } from 'react';
import { ScrollView, View } from 'react-native';
import { CardChartSection } from './CardChartSection';
import { CardTableSection } from './CardTableSection';
import { BiCardShown } from './functions/biCardShown';

/** The primary column: the card, then the rows behind it. */
export const CardDetailColumn = memo(
  ({
    shown,
    palette,
    dashboardFiltered,
    chartHeight,
    onRetry,
  }: {
    shown: BiCardShown;
    palette: BiPalette;
    dashboardFiltered: boolean;
    chartHeight: number;
    onRetry: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <ScrollView
        style={{ flex: 1 }}
        // The page sets the sides, so the card lines up with the header.
        contentContainerStyle={{ paddingVertical: rpx(16) }}
      >
        <View style={{ gap: rpx(16) }}>
          <CardChartSection
            shown={shown}
            palette={palette}
            dashboardFiltered={dashboardFiltered}
            chartHeight={chartHeight}
            onRetry={onRetry}
          />
          <CardTableSection shown={shown} />
        </View>
      </ScrollView>
    );
  },
);
